import React, { useState } from "react";

const Footer = () => {
  const [bgStyle] = useState({ backgroundColor: "#f5f5f5" });

  return (
    <footer style={bgStyle} className="mt-auto py-3 text-center">
      <i className="fas fa-code"></i> with <i className="fas fa-heart"></i> by{" "}
      <a
        className="badge badge-dark"
        rel="noopener"
        href="https://github.com/Brisingr1992"
        aria-label="My GitHub"
      >
        Dr. Alishea Nandiyil Suresh and Saushthav Saxena
      </a>{" "}
      using <i className="fab fa-react"></i>
      <p>
        <small className="text-muted">
          {" "}
          This website is created as a guide for parents and is just for reference. It should not be considered as the diagnosis or a treatment plan.
        </small>
      </p>
    </footer>
  );
};

export default Footer;